/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Moment from 'moment';
import { CALENDER_SCREEN, COMMON, API_CONSTANTS, ALL_ROUTES } from '../../global/Constants';
import { HeaderTypes } from "../../global/Enum";
import './activity-calendar.css';
import Header from '../common/Header';
import Footer from '../common/Footer';
import DesktopFooter from '../common/DesktopFooter';
import ApiServices from "../../providers/ApiServices";
import Loader from "../common/loader/Loader";
import Utilities from '../../global/Utilities';
import ViewImage from '../common/ViewImage';
import AcceptRejectButton from '../common/AcceptRejectButton';
import SyncLoader from '../common/loader/SyncLoader';


class IndividualVisitDetailsPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            isFarmer: true,
            activity: null,
            data: null,
            user: { name: "", phone: "" },
            address: "Fetching address..."
        }
    }

    componentDidMount() {
        if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
            if (this.props.location.state !== undefined) {
                let isFarmer = this.props.location.state.isFarmer;
                let activity = this.props.location.state.data;
                this.setState({ isFarmer: isFarmer, activity: activity });
                Utilities.LogPrint("Data:-->", activity);
                this.getActivityById(activity.activity_id);

            } else {
                this.props.history.replace(ALL_ROUTES.CALENDAR_ROUTE);
            }
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }
    }

    getActivityById(id) {
        this.setState({ isLoading: true });
        const request = JSON.stringify({
            activity_id: id
        });
        try {
            ApiServices.getActivityById(request)
                .then(response => {
                    Utilities.LogPrint("API_Activity_DATA: ---->", response);
                    this.setState({ isLoading: false });
                    if (response.success) {
                        const data = response.data;
                        if (data != null) {
                            let user = {}
                            if (data?.retailer_id === 0) {
                                user = {
                                    name: data?.krishak?.name,
                                    phone: data?.krishak?.phone
                                }
                            } else {
                                user = {
                                    name: data?.retailer?.retailer_name,
                                    phone: data?.retailer?.phone
                                }
                            }
                            this.setState({ data: data, user: user });

                            if (data?.individual_visit) {
                                const individualVisit = data?.individual_visit;
                                this.getAddressFromLatLong(individualVisit.latitude, individualVisit.longitude);
                            } else {
                                this.setState({ address: COMMON.LOCATION_ERROR_MESSAGE });
                            }

                        }
                    } else {
                        alert(response.message);
                        Utilities.LogPrint("Status", response.message);
                        if (response.message !== undefined && response.message) {
                            this.setState({
                                errorMsg: response.message
                            });
                        }
                    }
                }).catch(error => {
                    this.setState({ isLoading: false, errorMsg: error });
                });
        } catch (error) {
            this.setState({ isLoading: false, errorMsg: error });
        }
    }

    getAddressFromLatLong(latitude, longitude) {
        if (Utilities.isNetworkConnected()) {
            var body = JSON.stringify({
                latitude: latitude,
                longitude: longitude
            });
            try {
                ApiServices.getAddressFromLatLong(body).then(response => {
                    if (response.success) {
                        this.setState({ address: response.data.address });
                        Utilities.LogPrint("getAddressFromLatLongSuccess", response);
                    } else {
                        this.setState({ address: COMMON.LOCATION_ERROR_MESSAGE });
                        Utilities.LogPrint("getAddressFromLatLong", response);
                    }
                }).catch(error => {
                    Utilities.LogPrint("getAddressFromLatLong", error);
                });
            } catch (error) {
                this.setState({ address: COMMON.LOCATION_ERROR_MESSAGE });
                Utilities.LogPrint("getAddressFromLatLong", error);
            }
        }
    }


    getFormattedDate() {
        let selectedDate = null;
        if (this.props.location.state !== undefined) {
            selectedDate = this.props.location.state.selectedDate;
            return Moment(selectedDate).format('dddd, DD MMM, yyyy');
        }
    }

    handleBack = () => {
        this.props.history.goBack();
    }


    handleAcceptButton = () => {
        this.props.history.goBack();
    }

    handleRejectButton = () => {
        this.props.history.goBack();
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName)
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { isLoading, tableName, isSyncLoading, isFarmer, activity, data, address, user } = this.state;
        if (data != null) {
            const individualVisit = data?.individual_visit;
            return (
                <div>
                    <Header selectedTab={HeaderTypes.CALENDAR} handleSyncLoading={this.handleSyncLoading} />
                    <Footer isActive={1} />

                    <div className="container pt-35 pb-65">
                        <div className="row">
                            <div className="col-12">
                                <h3 className="title mb-0">{this.getFormattedDate()} Activities for {data?.user_name}</h3>
                                <p className="sub-title">{activity?.tehsil_name}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-6 col-lg-7 col-md-9 col-12">
                                <div className="activity-info-box yellow-activity mb-3 text-white max-w-460 my-3">
                                    <span>{activity?.activity_tag}</span>
                                    <h5>{`Individual Visit - ${isFarmer ? "Farmer" : "Retailer"}`} </h5>
                                    <span>{activity?.crop_name + ", " + activity?.hybrid_name + " | " + activity?.village_name}</span>
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-5 col-md-3 d-md-flex back-btn mt-3 d-none">
                                <button className="btn btn-secondary min-w-182 krishak-cancel-btn" onClick={this.handleBack}>{COMMON.BACK}</button>
                            </div>
                        </div>

                        {/* Reject Reason */}
                        {
                            data.activity_reject && data.activity_status_id === 4 ?
                                <div className="row">
                                    <div className="col-12 reject-activity-msg">
                                        <i className="customic ic-rejected"></i>
                                        <span>{data?.activity_reject?.reject?.title}.</span>
                                    </div>
                                </div> : null
                        }

                        <div className="row">
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-lg-4 col-md-6 col-12">
                                        <div className="row mb-3">
                                            <div className="col-lg-12 col-5 pr-0 pr-md-3 mb-md-2">{isFarmer ? CALENDER_SCREEN.FARMER_NAME : CALENDER_SCREEN.RETAILER_NAME}</div>
                                            <div className="col-lg-12 col-7">
                                                <span className="d-block font-weight-medium">{user?.name}</span>
                                                <span className="d-block font-weight-medium">+91 - {user?.phone}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-12">
                                        <div className="row mb-3">
                                            <div className="col-lg-12 col-5 pr-0 pr-md-3 mb-md-2">Stage of Visit</div>
                                            <div className="col-lg-12 col-7">
                                                <span className="d-block font-weight-medium">{individualVisit?.season?.season_name}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-lg-12 col-5 pr-0 pr-md-3 mb-md-2">Sub Activity</div>
                                            <div className="col-lg-12 col-7">
                                                <span className="d-block font-weight-medium">{individualVisit?.sub_activity?.sub_activity_name}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-12">
                                        <div className="row mb-3">
                                            <div className="col-lg-12 col-5 pr-0 pr-md-3 mb-md-2">Location</div>
                                            <div className="col-lg-12 col-7">
                                                {/* <span className="d-block font-weight-medium">Unnamed Road, Amargarh, Haryana 126116, India</span> */}
                                                <span className="d-block font-weight-medium">{address}</span>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-lg-4 col-md-6 col-12">
                                        <div className="row mb-3">
                                            <div className="col-lg-12 col-5 pr-0 pr-md-3 mb-md-2">Location</div>
                                            <div className="col-lg-12 col-7">
                                                <span className="d-block font-weight-medium">Unnamed Road, Amargarh, Haryana 126116, India</span>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                                <div className="row mx-sm-0">
                                    <hr className="w-100 bdr-color-gray m-0" />
                                </div>

                                <div className="row">
                                    {/* Remarks */}
                                    {
                                        individualVisit?.remark ?
                                            <div className="col-md-6 col-12">
                                                <span className="d-flex w-100 align-items-center mt-2">{COMMON.REMARKS}</span>
                                                <span className="d-flex font-weight-medium mb-2">{individualVisit?.remark}</span>

                                                <div className="row mx-sm-0 d-md-none">
                                                    <hr className="w-100 bdr-color-gray m-0" />
                                                </div>
                                            </div> : null
                                    }

                                    {/* Images */}
                                    {data?.activity_images.length ?
                                        <div className="col-md-6 col-12">
                                            <span className="font-weight-medium d-flex w-100 align-items-center mt-2 mb-2">{COMMON.IMAGES}</span>
                                            <div className="row row7-5 mb-3">
                                                {
                                                    data?.activity_images.map((image, i) => (
                                                        <ViewImage key={i} image={image.image_url} />
                                                    ))
                                                }
                                            </div>
                                        </div> : null
                                    }
                                </div>

                                <AcceptRejectButton
                                    activity={activity}
                                    handleAcceptButton={this.handleAcceptButton}
                                    handleRejectButton={this.handleRejectButton}
                                />
                            </div>
                        </div>
                    </div>
                    {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                    <DesktopFooter />

                </div>
            )
        } else {
            return (
                <div>
                    {isLoading ? <Loader /> : null}
                </div>
            );
        }
    }
}

export default withRouter(IndividualVisitDetailsPage)